import { PERSONA_STAGE_RESULTS_CLASS } from "../../../../lib/persona-opportunity-stage-chrome.js";
import { PersonaOpportunityEmptyPersonaState } from "../../../shared/PersonaOpportunityEmptyPersonaState/PersonaOpportunityEmptyPersonaState.js";
import { PersonaOpportunityPersonaGroupHeader } from "../../../shared/PersonaOpportunityPersonaGroupHeader/PersonaOpportunityPersonaGroupHeader.js";
import { PersonaOpportunityTable } from "../../../table/PersonaOpportunityTable/PersonaOpportunityTable.js";
import type { PersonaOpportunityPersonaGroup } from "../../../../lib/persona-opportunity-row-model.js";

export interface PersonaOpportunityTableViewProps {
  groups: PersonaOpportunityPersonaGroup[];
  expandedIds: ReadonlySet<string>;
  onToggleGroup: (personaId: string) => void;
  isGenerating?: boolean;
  selectedIds?: ReadonlySet<string>;
  selectionEnabled?: boolean;
  onToggleSelect?: (opportunityId: string) => void;
}

export function PersonaOpportunityTableView({
  groups,
  expandedIds,
  onToggleGroup,
  isGenerating = false,
  selectedIds,
  selectionEnabled = false,
  onToggleSelect,
}: PersonaOpportunityTableViewProps) {
  return (
    <div
      data-task-scroller=""
      className={`space-y-4 px-0 pb-4 pt-4 ${PERSONA_STAGE_RESULTS_CLASS}`}
    >
      {groups.map((group) => {
        const expanded = expandedIds.has(group.personaId);
        return (
          <section key={group.personaId} className="px-4">
            <PersonaOpportunityPersonaGroupHeader
              group={group}
              expanded={expanded}
              onToggle={() => onToggleGroup(group.personaId)}
              showProfileLists
            />
            {expanded ? (
              <div className="mt-2">
                {group.opportunities.length === 0 ? (
                  <PersonaOpportunityEmptyPersonaState isGenerating={isGenerating} />
                ) : (
                  <PersonaOpportunityTable
                    rows={group.opportunities}
                    selectedIds={selectedIds}
                    selectionEnabled={selectionEnabled}
                    onToggleSelect={onToggleSelect}
                  />
                )}
              </div>
            ) : null}
          </section>
        );
      })}
    </div>
  );
}
